<template>
    <wrapped-image
        :alt="alt"
        :fallback-image="fallbackImage"
        :image-classes="imageClasses"
        :sizes="sizes"
        :src="src"
        :srcset="srcset"
        :width="width"
        :with-gradient="withGradient"
        class="background-image"
    />
</template>

<script>
import WrappedImage from '@web/components/WrappedImage';

export default {
  components: {
    WrappedImage,
  },
  props: {
    srcset: {
      required: false,
      default:
                    '/img/web/services-slide-bg-480.jpg 480w, '
                    + '/img/web/services-slide-bg-1024.jpg 1024w, '
                    + '/img/web/services-slide-bg-1920.jpg 1920w, '
                    + '/img/web/services-slide-bg-3440.jpg 3440w',
    },
    sizes: {
      type: String,
      required: false,
      default: '',
    },
    src: {
      type: String,
      required: true,
      default: '/img/web/services-slide-bg-1024.jpg',
    },
    fallbackImage: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    imageClasses: {
      type: String,
      required: false,
      default: 'absolute w-full h-full object-cover',
    },
    width: {
      type: Number,
      required: false,
      default: null,
    },
    withGradient: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>
